import { Injectable } from '@angular/core';
import { Firestore, collection, collectionData, doc, addDoc, docData, CollectionReference, DocumentReference, updateDoc } from '@angular/fire/firestore';
import { from, Observable, of, throwError } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Song } from '../models/song.model';
import { DataService } from './data';

@Injectable({
  providedIn: 'root'
})
export class SongService {

  constructor(
    private firestore: Firestore, 
    private dataService: DataService) { }

  private getSongsCollectionRef(churchId: string): CollectionReference<Song> {
    if (!churchId) {
      throw new Error('Church ID is required to get songs collection reference.');
    }
    return collection(this.firestore, `iglesias/${churchId}/songs`) as CollectionReference<Song>;
  }

  getSongs(): Observable<Song[]> {
 return this.dataService.songs$;
  }

  getSong(id: string): Observable<Song> {
    return this.dataService.churchId$.pipe(
      switchMap(churchId => {
        if (churchId) {
          const songDocRef = doc(this.firestore, `iglesias/${churchId}/songs/${id}`);
          return docData(songDocRef, { idField: 'id' }) as Observable<Song>;
        } else {
          throw new Error('Church ID not available for getting song.');
        }
      }),
      take(1) // Tomar el primer valor y completar para getSong
    );
  }
  addSong(song: Song): Observable<DocumentReference<Song>> {
    return this.dataService.churchId$.pipe(
      switchMap(churchId => {
        if (churchId) {
          const songsRef = this.getSongsCollectionRef(churchId);
          return from(addDoc(songsRef, song)); // 🔁 Convertimos la promesa en observable
        } else {
          return throwError(() => new Error('Church ID not available for adding song.'));
        }
      })
    );
  }

  updateSong(songId: string, songData: Partial<Song>): Observable<void> {
    return this.dataService.churchId$.pipe(
      switchMap(churchId => {
        if (churchId) {
          const songDocRef = doc(this.firestore, `iglesias/${churchId}/songs/${songId}`);
          // updateDoc espera un DocumentReference y los datos a actualizar
          return from(updateDoc(songDocRef, songData));
        } else {
          return throwError(() => new Error('Church ID not available for updating song.'));
        }
      })
    );
  }

}
